module.exports = __webpack_public_path__ + "img/logo.b32b9a9e.png";